import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { colors } from '../../tokens/colors'
import { typography } from '../../tokens/typography'

const hover = css`
  background: ${colors.background.secondaryBackground};
  box-shadow: -3px 3px 0 0 ${colors.interactive.shadowHoverGray};
`

const focus = css`
  background: ${colors.background.secondaryBackground};
  box-shadow: 0 0 0 3px ${colors.interactive.shadowFocusOrange};
  border: 1px solid ${colors.interactive.borderFocusOrange};
  outline: none;
`

const animation = css`
  transform: translate(3px, -3px);
`

export const BookmarkWrapper = styled.div`
  position: absolute;
  right: 24px;
  padding: 2px;
  padding-top: 0px;
  top: 0;

  button {
    border-radius: 0px 0px 4px 4px;
  }
`

export const MediumCard = styled.div`
  position: relative;
  width: 240px;
  max-width: 480px;
  border-radius: 8px;
  background: ${colors.background.paper};
  transition: transform 100ms ease-in;
`

// small card itself is a button since there's no bookmark
export const SmallCard = styled.button`
  display: flex;
  width: 200px;
  max-width: 400px;
  height: 110px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: ${colors.background.paper};
  border: 1px solid ${colors.interactive.borderEnabledHoverGray};
  transition: transform 100ms ease-in;
  cursor: pointer;
  &:hover {
    ${hover}
    ${animation}
  }
  &:focus {
    ${focus}
    ${animation}
  }
  padding: 0;
  text-align: left;
`

export const LargeCard = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  min-width: 400px;
  border-radius: 8px;
  background: ${colors.background.paper};
  box-sizing: border-box;
  transition: transform 100ms ease-in;
  &:hover {
    ${animation}
  }
  &:focus {
    ${animation}
  }
`

export const LargeCardContent = styled.button`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  height: 100%;
  min-width: 400px;
  align-items: flex-start;
  padding: 0;
  background: none;
  border-radius: 8px;
  text-align: left;
  border: 1px solid ${colors.interactive.borderEnabledHoverGray};
  cursor: pointer;
  &:hover {
    ${hover}
  }
  &:focus {
    ${focus}
  }
`

export const LargeCardImage = styled.img`
  width: 100%;
  min-height: 100%;
  height: 100%;
  max-height: 100%;
  border-radius: 8px 0 0 8px;
  object-fit: cover;
`

export const CardImage = styled.img`
  width: calc(100% - 24px);
  height: 50%;
  border-radius: 4px;
  object-fit: cover;
  margin: 12px 12px 0 12px;
`

export const SmallCardDetails = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
`

export const LargeCardDetails = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  box-sizing: border-box;
  gap: 12px;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${colors.background.paper};
  transition: height 0.3s ease;
  z-index: 1;
`

export const CardSummary = styled.div`
  ${typography.down2.regularSans}
  color: ${colors.interactive.primaryEnabled};
  height: 0;
  overflow: hidden;
  opacity: 0;
  transition:
    height 0.2s ease,
    opacity 0.2s ease;
`

export const CardDetails = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 50%;
  box-sizing: border-box;
  gap: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${colors.background.paper};
  transition: height 0.3s ease;
  z-index: 1;
`

export const ChipWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: start;
`

export const LargeCardTitle = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  ${typography.down1.semiBoldSans}
  font-size: 18px;
  color: ${colors.interactive.primaryEnabled};
  margin-bottom: 9px;
`

export const CardTitle = styled.div`
${typography.down1.semiBoldSans}
  font-size: 18px;
  color: ${colors.interactive.primaryEnabled};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 9px;
`

export const MediumCardContent = styled.button`
  display: flex;
  flex-direction: column;
  height: 316px;
  width: 240px;
  max-width: 480px;
  padding: 0;
  background: none;
  border-radius: 8px;
  border: 1px solid ${colors.interactive.borderEnabledHoverGray};
  text-align: left;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &:hover {
    ${CardSummary} {
      height: auto;
      opacity: 1;
    }

    ${CardDetails} {
      height: 70%;
      background: ${colors.background.secondaryBackground};
    }
  }
`